import { EventOverbookingType as OverbookingType } from '../modules/booking/interfaces';
import {
  ALLOW_REDEEM_EVENT_BEFORE_SECONDS,
  RESTRICT_MODIFY_EVENT_BEFORE_SECONDS,
} from 'constants/booking.constants';

export function restrictModifyEventByTime(
  secondsBeforeEvent: number,
  restrictionBeforeDays?: number | null,
): boolean {
  let restrictionBeforeSeconds: number;

  if (restrictionBeforeDays) {
    restrictionBeforeSeconds = restrictionBeforeDays * 24 * 60 * 60;
  } else {
    restrictionBeforeSeconds = RESTRICT_MODIFY_EVENT_BEFORE_SECONDS;
  }

  return secondsBeforeEvent <= restrictionBeforeSeconds;
}

export function allowRedeemAppointmentByTime(secondsBeforeEvent: number): boolean {
  return secondsBeforeEvent <= ALLOW_REDEEM_EVENT_BEFORE_SECONDS;
}

export function isLimitedEvent(
  overbookingType: OverbookingType,
  bookedSpots: number,
  spotAmount: number,
  spotLimited: boolean,
) {
  if (overbookingType === OverbookingType.DO_NOT_ALLOW_OVERBOOKING) {
    return spotLimited && bookedSpots >= spotAmount;
  }

  return false;
}
